<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>爆版使用情况报表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="search(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
        </div>
        <el-collapse-transition>
          <div style="padding: 10px 25px">
            <el-form :inline="true" :model="form" class="demo-form-inline">
              <el-form-item prop="report_date">
                <span>报表日期:</span>
                <el-date-picker
                  v-model="form.report_date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="search">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="output">导出</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <el-table v-if="summary" :data="summary" border style="width: 100%">
          <el-table-column label="汇总" align="center">
            <el-table-column prop="binding_num" label="绑定爆版" align="center">
            </el-table-column>
            <el-table-column
              prop="unbinding_num"
              label="解绑爆版"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="open_order_ability_num"
              label="开通爆版开单"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cancel_order_ability_num"
              label="取消爆版开单"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="order_rate"
              label="订单数量/平台占比"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="kd_spu_rate"
              label="开单款数/平台占比"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="kd_rate"
              label="开单件数/平台占比"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="kd_num_and_spu_num"
              label="开单件数/款数"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="open_self_num"
              label="开通爆版上款"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cancel_self_num"
              label="取消爆版上款"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="open_all_style_num"
              label="开通全类目上款"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cancel_all_style_num"
              label="取消全类目上款"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="succeed_and_apply_self_spu_num"
              label="成功上款/全部申请"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="normal_spu_rate"
              label="成功上款（普通）/占比"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="all_spu_rate"
              label="成功上款（全类目）/占比"
              align="center"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <el-table
          v-if="reportdata"
          :data="reportdata"
          border
          style="width: 100%"
        >
          <el-table-column prop="report_date" label="报表日期" align="center">
          </el-table-column>
          <el-table-column prop="binding_num" label="绑定爆版" align="center">
          </el-table-column>
          <el-table-column prop="unbinding_num" label="解绑爆版" align="center">
          </el-table-column>
          <el-table-column
            prop="open_order_ability_num"
            label="开通爆版开单"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="cancel_order_ability_num"
            label="取消爆版开单"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="order_rate"
            label="订单数量/平台占比"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="kd_spu_rate"
            label="开单款数/平台占比"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="kd_rate"
            label="开单件数/平台占比"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="kd_num_and_spu_num"
            label="开单件数/款数"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="open_self_num"
            label="开通爆版上款"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="cancel_self_num"
            label="取消爆版上款"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="open_all_style_num"
            label="开通全类目上款"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="cancel_all_style_num"
            label="取消全类目上款"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="succeed_and_apply_self_spu_num"
            label="成功上款/全部申请"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="normal_spu_rate"
            label="成功上款（普通）/占比"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="all_spu_rate"
            label="成功上款（全类目）/占比"
            align="center"
          >
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}
</style>
<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  data() {
    return {
      loading: false,
      url: "/erp/Baob/getUsageReport",
      output_url: "/erp/Baob/outputUsageReport",
      form: {
        report_date: [],
      },
      summary: null,
      reportdata: null,
    };
  },
  methods: {
    search(showloading) {
      this.loading = !!showloading;
      this.$http.post(this.url, this.form).then((res) => {
        if (res.data.code != 200) {
          this.$message.error(res.data.msg);
        } else {
          this.summary = res.data.data.summary;
          this.reportdata = res.data.data.report;
        }
      });
      this.loading = false;
    },
    output() {
      this.$http.post(this.output_url, this.form).then((res) => {
        if (res.data.code != 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/BaobUsageData.vue